//
//  SDKThemeUtilities.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { UnreachableCaseError } from "../../utils/UnreachableCaseError";
import { TokenType } from "../enums/SDKTokenType";
import { BlurToken } from "../tokens/SDKBlurToken";
import { BorderToken } from "../tokens/SDKBorderToken";
import { ColorToken } from "../tokens/SDKColorToken";
import { BorderWidthToken, DimensionToken, DurationToken, FontSizeToken, LetterSpacingToken, LineHeightToken, OpacityToken, ParagraphSpacingToken, RadiusToken, SizeToken, SpaceToken, ZIndexToken, } from "../tokens/SDKDimensionToken";
import { GradientToken } from "../tokens/SDKGradientToken";
import { ShadowToken } from "../tokens/SDKShadowToken";
import { FontFamilyToken, FontWeightToken, ProductCopyToken, StringToken, } from "../tokens/SDKStringToken";
import { TextCaseToken } from "../tokens/SDKTextCaseToken";
import { TextDecorationToken } from "../tokens/SDKTextDecorationToken";
import { TypographyToken } from "../tokens/SDKTypographyToken";
import { VisibilityToken } from "../tokens/SDKVisibilityToken";
import cloneDeep from "lodash/cloneDeep";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ThemeUtilities {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Helpers
    /** Creates duplicate of the token */
    static replicateTokenAsThemePrefabWithoutValue(token, themeId, origin, versionId) {
        let replica;
        switch (token.tokenType) {
            case TokenType.blur:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BlurToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.border:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BorderToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.color:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ColorToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.gradient:
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new GradientToken(versionId, {}, [], null, [], []);
                break;
            case TokenType.dimension:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new DimensionToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.size:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new SizeToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.space:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new SpaceToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.opacity:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new OpacityToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.fontSize:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontSizeToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.lineHeight:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new LineHeightToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.letterSpacing:
                replica = new LetterSpacingToken(versionId, 
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                {}, 
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                null, null, [], []);
                break;
            case TokenType.paragraphSpacing:
                replica = new ParagraphSpacingToken(versionId, 
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                {}, 
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                null, null, [], []);
                break;
            case TokenType.borderWidth:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BorderWidthToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.radius:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new RadiusToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.duration:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new DurationToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.zIndex:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ZIndexToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.shadow:
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ShadowToken(versionId, {}, [], null, [], []);
                break;
            case TokenType.string:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new StringToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.productCopy:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ProductCopyToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.fontFamily:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontFamilyToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.fontWeight:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontWeightToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.typography:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new TypographyToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.textCase:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new TextCaseToken(versionId, {}, null, null, [], []);
                break;
            case TokenType.textDecoration:
                replica = new TextDecorationToken(versionId, 
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                {}, 
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                null, null, [], []);
                break;
            case TokenType.visibility:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new VisibilityToken(versionId, {}, null, null, [], []);
                break;
            default:
                throw new UnreachableCaseError(token.tokenType, "Unsupported type:");
        }
        replica.id = token.id;
        replica.idInVersion = token.idInVersion;
        replica.brandId = token.brandId;
        replica.themeId = themeId; // Assign just-created theme
        replica.designSystemVersionId = token.designSystemVersionId;
        replica.name = token.name;
        replica.description = token.description;
        replica.tokenType = token.tokenType;
        replica.origin = origin !== null && origin !== void 0 ? origin : null; // Re-direct origin to the other origin
        replica.parentGroupId = token.parentGroupId;
        replica.sortOrder = token.sortOrder;
        replica.properties = token.properties;
        replica.propertyValues = token.propertyValues;
        replica.createdAt = token.createdAt;
        replica.updatedAt = token.updatedAt;
        replica.resolutionState = token.resolutionState;
        // No replication of value - value will get replaced by the override
        return replica;
    }
    /** Creates duplicate of the token */
    static replicateTokenWithoutValue(token) {
        let replica;
        switch (token.tokenType) {
            case TokenType.blur:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BlurToken("", {}, null, null, [], []);
                break;
            case TokenType.border:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BorderToken("", {}, null, null, [], []);
                break;
            case TokenType.color:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ColorToken("", {}, null, null, [], []);
                break;
            case TokenType.gradient:
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new GradientToken("", {}, [], null, [], []);
                break;
            case TokenType.dimension:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new DimensionToken("", {}, null, null, [], []);
                break;
            case TokenType.size:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new SizeToken("", {}, null, null, [], []);
                break;
            case TokenType.space:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new SpaceToken("", {}, null, null, [], []);
                break;
            case TokenType.opacity:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new OpacityToken("", {}, null, null, [], []);
                break;
            case TokenType.fontSize:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontSizeToken("", {}, null, null, [], []);
                break;
            case TokenType.lineHeight:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new LineHeightToken("", {}, null, null, [], []);
                break;
            case TokenType.letterSpacing:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new LetterSpacingToken("", {}, null, null, [], []);
                break;
            case TokenType.paragraphSpacing:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ParagraphSpacingToken("", {}, null, null, [], []);
                break;
            case TokenType.borderWidth:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new BorderWidthToken("", {}, null, null, [], []);
                break;
            case TokenType.radius:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new RadiusToken("", {}, null, null, [], []);
                break;
            case TokenType.duration:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new DurationToken("", {}, null, null, [], []);
                break;
            case TokenType.zIndex:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ZIndexToken("", {}, null, null, [], []);
                break;
            case TokenType.shadow:
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ShadowToken("", {}, [], null, [], []);
                break;
            case TokenType.string:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new StringToken("", {}, null, null, [], []);
                break;
            case TokenType.productCopy:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new ProductCopyToken("", {}, null, null, [], []);
                break;
            case TokenType.fontFamily:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontFamilyToken("", {}, null, null, [], []);
                break;
            case TokenType.fontWeight:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new FontWeightToken("", {}, null, null, [], []);
                break;
            case TokenType.typography:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new TypographyToken("", {}, null, null, [], []);
                break;
            case TokenType.textCase:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new TextCaseToken("", {}, null, null, [], []);
                break;
            case TokenType.textDecoration:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new TextDecorationToken("", {}, null, null, [], []);
                break;
            case TokenType.visibility:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                replica = new VisibilityToken("", {}, null, null, [], []);
                break;
            default:
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                throw new UnreachableCaseError(token.tokenType, "Unsupported type:");
        }
        replica.id = token.id;
        replica.idInVersion = token.idInVersion;
        replica.brandId = token.brandId;
        replica.themeId = token.themeId;
        replica.collectionId = token.collectionId;
        replica.designSystemVersionId = token.designSystemVersionId;
        replica.name = token.name;
        replica.description = token.description;
        replica.tokenType = token.tokenType;
        replica.tokenPath = token.tokenPath;
        replica.origin = token.origin;
        replica.parentGroupId = token.parentGroupId;
        replica.sortOrder = token.sortOrder;
        replica.properties = token.properties;
        replica.propertyValues = token.propertyValues;
        replica.createdAt = token.createdAt;
        replica.updatedAt = token.updatedAt;
        replica.resolutionState = token.resolutionState;
        // No replication of value - value will get replaced by the override
        return replica;
    }
    /** Creates duplicate of the token */
    static replicateTokenWithValue(token) {
        const replica = this.replicateTokenWithoutValue(token);
        replica.value = cloneDeep(token.value);
        return replica;
    }
}
